import * as types from './types';

export default {
  state: {
    students: [],
    textarea: '',
    studentPhone: [],
  },
  getters: {
    [types.STUDENTS]: state => state.students,
    [types.TEXTAREA]: state => state.textarea,
    [types.STUDENT_PHONE]: state => state.studentPhone,
  },
  mutations: {
    [types.STUDENTS]: (state, payload) => {
      state.students = payload.students;
    },
    [types.TEXTAREA]: (state, payload) => {
      state.textarea = payload.textarea;
    },
    [types.STUDENT_PHONE]: (state, payload) => {
      state.studentPhone = payload.studentPhone;
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/school/school-detail/instead/index.js